import useAppQuery from 'hooks/useAppQuery';
import API from 'services/API';
import { getUnitType } from 'utils/lead/leadUtils';
import { GetAllICalsResponse } from 'models/ICal';
import { Property } from 'models/Properties';

export const ICALS_BASE_QUERY_KEY = 'icals';

const useFetchIcals = (propertyUid: string, allProperties: Property[]) => {
  const { data, isFetching } = useAppQuery(
    [ICALS_BASE_QUERY_KEY, propertyUid],
    async () => {
      const unitType = getUnitType(allProperties || [], propertyUid);
      const response = await API.get<GetAllICalsResponse>(
        '/api/internal/icals',
        {
          params: {
            [unitType ? 'unitsUids' : 'propertiesUids']: propertyUid,
          },
        },
      );

      return response.data?.icals || [];
    },
    { enabled: !!propertyUid },
  );

  return { data, isFetching };
};

export default useFetchIcals;
